import "./SwitchComponent.css";

const SwitchComponent = ({ checked, onChange }) => {
  return (
    <div
      className={`switch-component ${checked ? "checked" : ""}`}
      onClick={() => onChange(!checked)}
    >
      <div className={`knob ${checked ? "knob-checked" : ""}`}></div>
    </div>
  );
};
export default SwitchComponent;
